import React from "react";
import { ShieldCheck, Wrench, Network } from "lucide-react";

const ABOUT_IMG =
  "https://images.pexels.com/photos/36823725/pexels-photo-36823725.jpeg";

export const About = () => {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative py-24 lg:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 reveal">
            <span className="section-tag">01 / Nosotros</span>
            <h2 className="mt-6 font-display font-extrabold text-4xl sm:text-5xl lg:text-[56px] leading-[0.98] tracking-tight">
              Especialistas en infraestructura crítica para el corredor
              industrial{" "}
              <span className="text-[#F8BC33]">Saltillo–Ramos Arizpe</span>.
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-10">
            <div className="reveal reveal-delay-1 grid sm:grid-cols-5 gap-8 items-start">
              <div className="sm:col-span-2 relative overflow-hidden border border-white/10">
                <img
                  src={ABOUT_IMG}
                  alt="Planta industrial moderna en Saltillo"
                  className="w-full h-56 sm:h-full object-cover transition-transform duration-700 hover:scale-105"
                  data-testid="about-image"
                />
              </div>
              <div className="sm:col-span-3 space-y-5 text-white/75 text-base leading-relaxed">
                <p>
                  INFRATELCO es una empresa coahuilense con más de 15 años
                  diseñando, desplegando y manteniendo infraestructura
                  tecnológica y de telecomunicaciones para plantas
                  manufactureras, maquiladoras y desarrollos industriales.
                </p>
                <p>
                  Operamos desde Saltillo con cobertura en todo el noreste de
                  México. Nuestro equipo certificado integra seguridad
                  electrónica, redes empresariales, fibra óptica y climatización
                  bajo un único interlocutor —reduciendo riesgos, tiempos y
                  paros de producción.
                </p>
              </div>
            </div>

            <div className="reveal reveal-delay-2 grid sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
              {[
                {
                  icon: ShieldCheck,
                  title: "Certificaciones",
                  text: "Cumplimiento NOM, IEC y mejores prácticas TIA/EIA.",
                },
                {
                  icon: Wrench,
                  title: "Llave en mano",
                  text: "Diseño, suministro, instalación y mantenimiento.",
                },
                {
                  icon: Network,
                  title: "Multidisciplina",
                  text: "Un solo proveedor para 6 verticales críticas.",
                },
              ].map((c) => (
                <div
                  key={c.title}
                  className="bg-[#181C24] p-7 hover:bg-[#212731] transition-colors"
                  data-testid={`about-card-${c.title}`}
                >
                  <c.icon className="w-6 h-6 text-[#F8BC33]" strokeWidth={1.5} />
                  <h3 className="mt-5 font-display font-bold text-lg">
                    {c.title}
                  </h3>
                  <p className="mt-2 text-sm text-white/60 leading-relaxed">
                    {c.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
